import Swiper from 'swiper';
import 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const initBlock = function( $block ) {
	$block.each( function() {
		const $sectionInstance = $( this );
		const $thumbsSlider = $sectionInstance.find( '.js-our-story-thumbs' );
		const $mainSlider = $sectionInstance.find( '.js-our-story-slider' );
		const collapsedBlocks = $sectionInstance.find( '.js-collapse' );
		const thumbsSlider = $thumbsSlider[0];
		const mainSlider = $mainSlider[0];

		if ( !thumbsSlider || !mainSlider || thumbsSlider.swiper || mainSlider.swiper ) {
			return;
		}

		const thumbsSwiper = new Swiper( thumbsSlider, {
			slidesPerView: 'auto',
			spaceBetween: 60,
			centerInsufficientSlides: true,
			freeMode: true,
			watchSlidesProgress: true,
			breakpoints: {
				768: {
					spaceBetween: 80,
				},
			},
			a11y: {
				enabled: false,
			},
		} );

		const mainSwiper = new Swiper( mainSlider, {
			slidesPerView: 1,
			effect: 'fade',
			fadeEffect: {
				crossFade: true,
			},
			autoHeight: true,
			thumbs: {
				swiper: thumbsSwiper,
			},
			a11y: {
				enabled: false,
			},
		} );

		$( thumbsSlider ).find( '.swiper-slide' ).on( 'click', function() {
			thumbsSwiper.slideTo( $( this ).index() );
		} );

		const resizeObserver = new ResizeObserver( entries => {
			for ( let entry of entries ) {
				const currentHeight = entry.target.clientHeight;
				const previousHeight = entry.target.dataset.previousHeight || 0;

				if ( currentHeight !== previousHeight ) {
					mainSwiper.updateAutoHeight();
					entry.target.dataset.previousHeight = currentHeight;
				}
			}
		} );

		collapsedBlocks.each( ( index, collapsedBlock ) => {
			resizeObserver.observe( collapsedBlock );
		} );
	} );
};

app.loadBlock( initBlock, 'our-story', '.section-our-story' );

if ( module.hot ) {
	module.hot.accept();
}
